// SidebarNavigation.js
import React from 'react';
import { Link,useNavigate } from 'react-router-dom';
import '../styles/SidebarNav.css';
//import { useAuth } from "../functions/AuthContext";
//import {auth} from '../functions/firebase';
import { useAuth } from "react-oidc-context";


const SidebarNav = () => {
  //const { isAuthenticated, user } = useAuth();
  const auth = useAuth();
  const navigate=useNavigate();

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    localStorage.setItem('auth_user',JSON.stringify(auth.user));
    return (
      <div>
        <pre> Hello: {auth.user?.profile.email} </pre>
        <pre> ID Token: {auth.user?.id_token} </pre>
        <pre> Access Token: {auth.user?.access_token} </pre>
        <pre> Refresh Token: {auth.user?.refresh_token} </pre>
        <button onClick={() => auth.removeUser()}>Sign out</button>
      </div>
    );
  }

  const signOutRedirect = () => {
    const clientId = "63lshnga7pf7jc29penkr0jclf";
    const logoutUri = "<logout uri>";
    const cognitoDomain = "https://<user pool domain>";
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };

  return (
    <div className="sidebar-navigation">
      <nav>
        <ul>
          <li>
            <Link to="/landing/word-learn">শব্দ শিখুন</Link>
          </li>
          <li>
            <Link to="/landing/word-exam">শব্দ পরীক্ষা দিন</Link>
          </li> 
          <li>
            <Link to="/landing/sentence-learn">বাক্য শিখুন</Link>
          </li>
          <li>
            <Link to="/landing/sentence-exam">বাক্য পরীক্ষা দিন</Link>
          </li>
          <li>
            <Link to="/landing/subject-choice">স্কুল ক্লাস</Link>
          </li>
          <li>
            <Link to="/landing/report-card">রিপোর্ট কার্ড</Link>
          </li>
          <li>
            <Link to="/landing/support">সাহায্য</Link>
          </li>
          <li>
            {/*isAuthenticated?(<button onClick={handleLogout}>লগ আউট</button>):(<Link to="/social-login">লগইন</Link>)*/}
            {auth.isAuthenticated?(<button onClick={signOutRedirect}>লগ আউট</button>):
            (<button  onClick={() => auth.signinRedirect()}>লগইন</button>)}
          </li>

        </ul>
      </nav>
    </div>
  );
};

export default SidebarNav;
